import { useSearchParams } from 'react-router'
import { useMyAbstractAccountAddress } from 'hooks/useAbstractAccountAddress'
import { Address } from 'use-towns-client'

export function useGetAssetSourceParam() {
    const [searchParams] = useSearchParams()
    return searchParams.get('assetSource') as Address | undefined
}

export function useIsAAWallet() {
    const currentWallet = useGetAssetSourceParam()
    const { data: aaAddress } = useMyAbstractAccountAddress()
    return currentWallet === aaAddress
}

export function isAddress(value: string | undefined): value is Address {
    if (!value) {
        return false
    }
    return /^0x[a-fA-F0-9]{40}$/.test(value)
}
